import { render } from "./PlayerEarnings.vue?vue&type=template&id=4c7877b9&scoped=true"
import script from "./PlayerEarnings.vue?vue&type=script&lang=js"
export * from "./PlayerEarnings.vue?vue&type=script&lang=js"

import "./PlayerEarnings.vue?vue&type=style&index=0&id=4c7877b9&lang=scss&scoped=true"

import exportComponent from "E:\\LEIGH_STORE\\PROJECTS\\2-PROJECTS\\6-PIYOOK\\ICS-Digital\\1-Dominic-Projects\\7-football-earnings\\5-website\\footy-earnings\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7877b9"]])

export default __exports__